import React, { useEffect, useState } from 'react'
import './Rows.css'
import { getDailyTrending, getFeed, getPremiumFeed } from '../../services/f';
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../features/currentUser';
import { Oval } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';

function Rows({ title, isLargeRow = false }) {

    let currentUser = useSelector(getCurrentUser).currentUser?.currentUser

    // by default islargerow is false other when specified true as prop
    // with props get things from homescreen
    const [posts, setposts] = useState([]);
    const [isrefreshing, setisrefreshing] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {

        if (auth.currentUser === undefined || auth.currentUser === null) {
            //console.log("user undefined")
            if (title === "Trending") {
                //console.log("load trending")
                setposts([])
                getDailyTrending(undefined).then((posts) => (setposts(posts), setisrefreshing(false)))
                //getFeed(undefined).then((posts) => (setposts(posts), setisrefreshing(false)))
            } else if (title === "Feed") {
                //console.log("load Feed")
                setposts([])
                getFeed(undefined).then((posts) => (setposts(posts), setisrefreshing(false)))
            } else if (title === "Premium") {
                //console.log("user undefined")
                setisrefreshing(false)
                setposts(["nopremium"])
            }
        } else {
            if (title === "Trending") {
                //console.log("load trending")
                setposts([])
                //getDailyTrending(currentUser).then((posts) => (setposts(posts), setisrefreshing(false)))
                getFeed(undefined).then((posts) => (setposts(posts), setisrefreshing(false)))

            } else if (title === "Feed") {
                //console.log("load Feed")
                setposts([])
                getFeed(currentUser).then((posts) => (setposts(posts), setisrefreshing(false)))
            } else if (title === "Premium") {
                if ((currentUser !== null && currentUser !== undefined && currentUser?.premium === true && currentUser?.premiumend > (new Date().getTime() / 1000))) {
                    //console.log("load Premium")
                    setposts([])
                    getPremiumFeed(currentUser).then((posts) => (/*console.log(posts)*/ setposts(posts), setisrefreshing(false)))
                } else {
                    //console.log("has no Premium")
                    setisrefreshing(false)
                    setposts(["nopremium"])
                }
            }
        }
    }, [currentUser]);

    useEffect(() => {
        if (title === "Trending") {
            setisrefreshing(true)
        } else if (title === "Feed") {
            setisrefreshing(true)
        } else if (title === "Premium") {
            if ((currentUser !== null && currentUser !== undefined && currentUser?.premium === true && currentUser?.premiumend > (new Date().getTime() / 1000))) {
                setisrefreshing(true)
            } else {
                setisrefreshing(false)
            }
        }
    }, []);

    /*
    useEffect(() => {
        console.log("array to", [...posts, "seemore"])
    }, [posts]);
*/
    return (
        <div className='row'>
            <h2 class="section-title">{title}</h2>
            <div className='row__posters'>
                {isrefreshing
                    ?
                    <Oval
                        height={25}
                        width={25}
                        color="#009FFD"
                        wrapperStyle={{ width: 40, flex: "display", alignItems: "center", justifyContent: "center" }}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="white"
                        strokeWidth={5}
                        strokeWidthSecondary={5}
                    />
                    :
                    (posts.length === 1 && posts[0] === "nopremium"
                        ?
                        <div class="premium-card">
                            <div class="premium-content">
                                <h3>Unfortunately you are not subscribed to Premium+</h3>
                                <div class="premium-price">Only $3.49 per month!</div>
                                <p>Unlock exclusive content, ad-free experience, and premium features</p>
                                <button onClick={() => navigate("/profile")} class="btn-premium">Learn More</button>
                            </div>
                        </div>
                        :
                        [...posts, "seemore"].map((post) =>
                        (post === "seemore"
                            ?
                            <div class="feed-cta">
                                <h3>You like what you see?</h3>
                                <p>See more in our App!</p>
                                <a href="app" class="btn">Download Now!</a>
                            </div>
                            :
                            <img
                                loading="lazy"
                                onClick={() => (/*console.log("clicked pos")*/ navigate("/post?id=" + post[0]))}
                                className={`row__poster ${isLargeRow && "row__posterLarge"}`}
                                key={post[0]}
                                src={post[1].type === "image" ? post[1]?.media[0] : post[1]?.media[1]}
                                alt={"Premsi post " + post[1]?.description} />
                        ))
                    )
                }
            </div>
        </div>
    )
}

export default Rows
